import axios from "axios";
import alert from "@/lang/AlertMessages";

export default {
  getAllRequests({ dispatch, commit }, data) {
    axios
      .get("Kara/ListRequest?" + data + "&OrderBy=id desc")
      .then((res) => {
        commit("setAllRequests", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagerAllRequests({ dispatch, commit }, data) {
    axios
      .get("Kara/ListManagerRequest?" + data + "&OrderBy=id desc")
      .then((res) => {
        commit("setManagerAllRequests", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  confirmRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AcceptOrRejectRequest", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRemainLeaves({ dispatch, commit }) {
    axios
      .get("Kara/RemainLeaveDay")
      .then((res) => {
        commit("setRemainLeaves", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDailyWorks({ dispatch, commit }, data) {
    axios
      .get("Kara/ListDailyWork?date=" + data)
      .then((res) => {
        if (res.data.data) {
          commit("setDailyWorks", res.data.data.$values);
        } else {
          commit("setDailyWorks", []);
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  //  Leave Request Actions - ---------------------------------------------------
  addLeaveRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AddMorakhasi", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "LeaveRequestList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addHourLeaveRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AddMorakhasiSaati", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "LeaveRequestList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeaveRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/UpdateMorakhasi", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "LeaveRequestList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editHourLeaveRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/UpdateMorakhasiSaati", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "LeaveRequestList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeaveRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Kara/DeleteMorakhasi/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteHourLeaveRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Kara/DeleteMorakhasiSaati/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  Over Time (ExtraWork) Request Actions - ---------------------------------------------------
  addExtraWorkRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AddOverTime", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "ExtraWorkList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editExtraWorkRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/UpdateOverTime", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "ExtraWorkList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteExtraWorkRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Kara/DeleteOverTime/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  Mission Request Actions - ---------------------------------------------------
  addMissionRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AddMission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "MissionList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addHourMissionRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AddHourMission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "MissionList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editMissionRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/UpdateMission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "MissionList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editHourMissionRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/UpdateHourMission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "MissionList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteMissionRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Kara/DeleteMission/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteHourMissionRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Kara/DeleteHourMission/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  Forgotten Traffic Request Actions - ---------------------------------------------------
  addTrafficRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/AddForgettingTraffic", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "ExpertForgetList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTrafficRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Kara/UpdateForgettingTraffic", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "ExpertForgetList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTrafficRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Kara/DeleteForgettingTraffic/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Insurance Lists --------------------------------------------------------------
  getInsuranceList({ dispatch, commit }) {
    axios
      .get("Insurance/InsuranceContract?date=1402")
      .then((res) => {
        commit("setInsuranceList", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceFee({ dispatch, commit }, data) {
    axios
      .get("Insurance/InsuranceContract?date=" + data)
      .then((res) => {
        commit("setInsuranceFee", res.data.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceFeeTitle({ dispatch, commit }, data) {
    axios
      .get("Insurance/InsuranceContract?date=" + data)
      .then((res) => {
        commit("setInsuranceFeeTitle", res.data.data2);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Suggestion (CR) Actions ------------------------------------------------------------
  getSuggestions({ dispatch, commit }) {
    axios
      .get("Suggestion/ListSuggestion?Page=1&PageSize=100000")
      .then((res) => {
        commit("setSuggestionList", res.data.data.$values);
        commit("setPageTotal", res.data.rowCount.$values[0]);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagerSuggestions({ dispatch, commit }, data) {
    axios
      .get(
        "Suggestion/ListSuggestionManager?" +
          "Page=" +
          data.pageNumber +
          "&PageSize=" +
          data.pageSize
      )
      .then((res) => {
        commit("setManagerSuggestionList", res.data.data.$values);
        commit("setPageTotal", res.data.rowCount.$values[0]);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSuggestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Suggestion/AddOrEditSuggestion", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "CrList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  answerSuggestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Suggestion/AnswerSuggestion", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "CrList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  receiveSuggestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Suggestion/ReceiveSuggestion/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSuggestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Suggestion/DeleteSuggestion/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDepartments({ dispatch, commit }) {
    axios
      .get("Department/ListDepartmanMyMirab")
      .then((res) => {
        commit("setDepartments", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Poll Actions ------------------------------------------------------------------
  getExpertPollHeaders({ dispatch, commit }) {
    axios
      .get("Poll/ListPollExpert?Page=1&PageSize=100000&OrderBy=id desc")
      .then((res) => {
        commit("setExpertPollHeaders", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagerPollHeaders({ dispatch, commit }) {
    axios
      .get("Poll/ListPollManager?OrderBy=id desc")
      .then((res) => {
        commit("setManagerPollHeaders", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getManagerPollsHistory({ dispatch, commit }) {
    axios
      .get("Poll/ListPollHeaderHistoryManager?OrderBy=id desc")
      .then((res) => {
        commit("setManagerPollsHistory", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserPollHeaders({ dispatch, commit }) {
    axios
      .get("Poll/ListPollUser?OrderBy=id desc")
      .then((res) => {
        commit("setUserPollHeaders", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPollDetails({ dispatch, commit }, data) {
    axios
      .get(
        "Poll/ListPollDetails?Filter=PollHeaderRef=" + data + "&OrderBy=id desc"
      )
      .then((res) => {
        if (res.data.data && res.data.data.$values) {
          commit("setPollDetails", res.data.data.$values);
        } else {
          commit("setPollDetails", []);
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAnswerPollHeaders({ dispatch, commit }) {
    axios
      .get("Poll/ListAnswerPollHeader?OrderBy=id desc")
      .then((res) => {
        commit("setAnswerPollHeaders", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAnswerPollDetails({ dispatch, commit }, data) {
    axios
      .get(
        "Poll/ListAnswerPollDetails?Page=1&PageSize=10000&Filter=PollHeaderRef=" +
          data +
          "&OrderBy=id desc"
      )
      .then((res) => {
        commit("setAnswerPollDetails", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserAnswerPollHeaders({ dispatch, commit }) {
    axios
      .get("Poll/ListPollHeaderAnswerUser?Page=1&PageSize=100000")
      .then((res) => {
        commit("setUserAnswerPollHeaders", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserAnswerPollDetails({ dispatch, commit }, data) {
    axios
      .get(
        "Poll/ListPollDetailsAnswerUser?Filter=PollHeaderRef=" +
          data +
          "&OrderBy=id desc"
      )
      .then((res) => {
        commit("setUserAnswerPollDetails", res.data.data.$values);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPoll({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Poll/AddOrEditPoll", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  answerPoll({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });

    axios
      .post("Poll/AnswerPoll", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deletePoll({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Poll/DeletePoll/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeState({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("State/ChangeState", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changeStatus,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
